module.exports = __webpack_public_path__ + "media/images/promo/bg_card_3-6db420630e7c704ef85d36cb9214ed2b.jpg";